import { render, staticRenderFns } from "./StudentEmails.vue?vue&type=template&id=20091782&scoped=true&"
import script from "./StudentEmails.vue?vue&type=script&lang=js&"
export * from "./StudentEmails.vue?vue&type=script&lang=js&"
import style0 from "./StudentEmails.vue?vue&type=style&index=0&id=20091782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20091782",
  null
  
)

export default component.exports